import React from 'react';
export function Bonuses() {
  const bonuses = [{
    title: 'Dominio Total en PLC y Automatización',
    desc: 'Aprendé a programar y operar controladores lógicos programables desde cero. La habilidad más buscada en el mercado industrial hoy.',
    value: '$67 USD'
  }, {
    title: 'Instalaciones Eléctricas Domiciliarias Pro',
    desc: 'Todo lo que necesitás para hacer instalaciones residenciales correctas, seguras y bajo norma técnica.',
    value: '$47 USD'
  }, {
    title: 'Tablerista Eléctrico de Élite',
    desc: 'Armá tableros eléctricos de forma profesional, ordenada y segura como lo hacen los mejores técnicos.',
    value: '$37 USD'
  }, {
    title: 'Biblioteca Maestra de Planos y Diagramas',
    desc: 'Los diagramas eléctricos más usados en la industria, listos para consultar en tu celular cuando los necesitás.',
    value: '$37 USD'
  }, {
    title: 'Protocolo Antifallas: Revisión y Prueba Eléctrica',
    desc: 'El checklist profesional para revisar cualquier instalación o tablero antes de energizar y evitar errores costosos.',
    value: '$27 USD'
  }, {
    title: 'Guía para Cobrar como un Profesional',
    desc: 'Aprendé a cotizar trabajos eléctricos con criterio, presentar presupuestos y dejar de regalar tu trabajo.',
    value: '$27 USD'
  }];
  return <section className="bg-brand-surface text-brand-text px-4 py-10" data-id="element-13">
      <div className="max-w-xl mx-auto" data-id="element-14">
        <h2 className="text-xl md:text-2xl font-black text-center mb-6 text-yellow" data-id="element-15">
          🎁 Y ADEMÁS, CON TU COMPRA DE HOY TE LLEVÁS ESTOS 6 REGALOS
        </h2>

        <div className="space-y-3" data-id="element-16">
          {bonuses.map((b, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-lg p-4" data-id="element-17">
              <p className="text-xs font-bold uppercase tracking-widest text-brand-green mb-1" data-id="element-18">
                🎁 Regalo {i + 1} — GRATIS
              </p>
              <p className="font-black text-white mb-1.5" data-id="element-19">{b.title}</p>
              <p className="text-sm text-brand-muted leading-relaxed mb-2" data-id="element-20">
                {b.desc}
              </p>
              <p className="text-sm font-bold text-brand-muted" data-id="element-21">
                Valor real: <span className="line-through" data-id="element-22">{b.value}</span>{' '}
                <span className="text-yellow" data-id="element-23">— HOY GRATIS</span>
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}